import _toConsumableArray from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { color, complex } from 'style-value-types';
import { dimensionValueTypes } from './dimensions.mjs';
import { testValueType } from './test.mjs';

/**
 * A list of all ValueTypes
 */
var valueTypes = [].concat(_toConsumableArray(dimensionValueTypes), [color, complex]);
/**
 * Tests a value against the list of ValueTypes
 */
var findValueType = function findValueType(v) {
  return valueTypes.find(testValueType(v));
};
export { findValueType };